import { topicItems } from '@/mocks/home';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-800 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-800 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            剧迷们正在热烈讨论的热门话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#hero"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium cursor-pointer no-underline transition-colors ${colorMap[item.color] || colorMap.primary}`}
            >
              <span>{item.name}</span>
              <span className="text-[10px] opacity-70 font-normal">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}